module.exports = __webpack_public_path__ + "static/media/american-samoa.0bb78bce.svg";